import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=511d967d&scoped=true&"
import script from "./SuggestionList.vue?vue&type=script&lang=js&"
export * from "./SuggestionList.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=511d967d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d967d",
  null
  
)

export default component.exports